import * as S from './styles.ts';
import TableCard, { TItem } from './TableCard';

interface ITableProps {
  items: TItem[];
  onSelect: (key: string | number) => void;
}

const Table = ({ items, onSelect }: ITableProps) => {
  return (
    <S.TableWrapper>
      <S.TableContainer>
        {items.map((item) => (
          <TableCard
            item={item}
            key={item.key}
            onSelect={() => onSelect(item.key)}
          />
        ))}
      </S.TableContainer>
    </S.TableWrapper>
  );
};

export default Table;
